/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "./Toggle.module.scss";
import { GetAdminDetailsByID, PutAdminAvailability } from "../../apiServices";
import { useDispatch } from "react-redux";
import { CandidatePipelineActions } from "../../redux-store/store";
import { decryptedAdminID } from "../../utility";

const ToggleSwitch = ({ label }) => {
  const Dispatch = useDispatch();
  const [checkAdmin, setCheckAdmin] = useState({
    emailId: "",
    available: false,
  });

  useEffect(() => {
    // Fetch the admin details by ID and update checkAdmin
    const adminID = decryptedAdminID();
    if (adminID != null) {
      GetAdminDetailsByID(adminID).then((data) => {
        setCheckAdmin({
          emailId: data.admin.emailId,
          available: data.admin.isAvailable,
        });
      });
    }
    Dispatch(CandidatePipelineActions.setRefreshCount());
  }, []);

  const handleToggleChange = () => {
    const newAvailability = !checkAdmin.available;

    setCheckAdmin((prevState) => ({
      ...prevState,
      available: newAvailability,
    }));

    PutAdminAvailability({
      emailId: checkAdmin.emailId,
      available: newAvailability,
    }).then((data) => {
      const adminID = decryptedAdminID();
      if (adminID) {
        GetAdminDetailsByID(adminID).then((data) => {
          setCheckAdmin({
            emailId: data.admin.emailId,
            available: data.admin.isAvailable,
          });
        });
      }
    });

    Dispatch(CandidatePipelineActions.setRefreshCount());
  };

  return (
    <div className={styles.container}>
      {label}
      <div className={styles["toggle-switch"]}>
        <input
          type="checkbox"
          className={styles.checkbox}
          name={label}
          id={label}
          checked={checkAdmin.available}
          onChange={handleToggleChange}
        />
        <label className={styles.label} htmlFor={label}>
          <span className={styles.inner} />
          <span className={styles.switch} />
        </label>
      </div>
    </div>
  );
};

export default ToggleSwitch;
